import { AppTooltip } from '@components'
import { InfoIcon } from 'lucide-solid'
import type { ParentProps } from 'solid-js'
import { Grid } from 'styled-system/jsx'

export function FieldInformation(props: ParentProps & { information?: string }) {
	return (
		<Grid
			gridTemplateColumns="auto 1fr"
			gap="1"
			alignItems="center"
		>
			<AppTooltip
				content={props.information}
				openDelay={0}
				positioning={{
					placement: 'right',
				}}
			>
				<InfoIcon size={12} />
			</AppTooltip>
			{props.children}
		</Grid>
	)
}
